import { render, staticRenderFns } from "./ChannelInfoCard.vue?vue&type=template&id=1829f9ab"
import script from "./ChannelInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelInfoCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports